import styled from "styled-components";

import { media } from "../styles/media";

export const AnalyticsStyles = styled.section`
  min-height: calc(100vh - 42px);

  .grid-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .grid-1 {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .grid-2.grid-2--ratings {
    margin-bottom: 16px;
  }

  .row-spacer {
    margin-top: 16px;
  }

  .dash-footer {
    margin-top: 40px;
    padding: 20px 0;
    border-top: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};

    ${media.maxMobile`
      flex-direction: column;
      gap: 4px;
    `}
  }

  @media (max-width: 1300px) {
    .grid-2 {
      grid-template-columns: 1fr;
    }
  }

  /* Plans without access_to_analytics get this instead of the dashboard. */
  .plan-upsell .panel-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 14px;
    padding: 64px 24px;
  }
`;
